import { HQ } from "../sportConfig";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ApiUsage.css";

const sum = (rows) => rows.reduce((total, row) => total + row.count, 0);

export default function ApiUsage() {
  const [key, setKey] = useState("");
  const [rows, setRows] = useState(null);
  const [dates, setDates] = useState([]);
  const [today, setToday] = useState("");
  const [needsKey, setNeedsKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    fetch(`${HQ.dataApi}/admin${HQ.dataApi}-usage`, { cache: "no-store" }).then(async (response) => {
      if (response.status === 403) { if (active) setNeedsKey(true); return; }
      if (!response.ok) throw new Error("Statistiken kunde inte hämtas. Försök igen.");
      const data = await response.json();
      if (active) { setRows(data.rows || []); setDates(data.days || []); setToday(data.today || ""); }
    }).catch((caught) => { if (active) setError(caught.message); });
    return () => { active = false; };
  }, []);

  const load = async (event) => {
    event?.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${HQ.dataApi}/admin${HQ.dataApi}-usage`, { headers: { "X-Admin-Token": key }, cache: "no-store" });
      if (response.status === 403) throw new Error("Nyckeln stämmer inte, eller så är adminvyn inte aktiverad.");
      if (!response.ok) throw new Error("Statistiken kunde inte hämtas. Försök igen.");
      const data = await response.json();
      setRows(data.rows || []);
      setDates(data.days || []);
      setToday(data.today || "");
    } catch (caught) {
      setError(caught.message);
    } finally {
      setLoading(false);
    }
  };

  const dailyTotals = (rows || []).reduce((result, row) => {
    result[row.day] = (result[row.day] || 0) + row.count;
    return result;
  }, {});
  const days = dates.map((day) => [day, dailyTotals[day] || 0]);
  const providers = Object.entries((rows || []).reduce((result, row) => {
    result[row.provider] = (result[row.provider] || 0) + row.count;
    return result;
  }, {})).sort((a, b) => b[1] - a[1]);
  const routes = Object.entries((rows || []).reduce((result, row) => {
    const route = `${row.provider} · ${row.endpoint}`;
    result[route] = (result[route] || 0) + row.count;
    return result;
  }, {})).sort((a, b) => b[1] - a[1]);
  const failures = sum((rows || []).filter((row) => row.outcome === "network_error" || Number(row.outcome) >= 400));
  const peak = Math.max(1, ...days.map(([, count]) => count));

  return <main className="api-usage">
    <Link to="/">← Matcher</Link>
    <header><span>Administration</span><h1>Externa API-anrop</h1><p>Faktiska anrop till externa tjänster under de senaste 30 dagarna. Cacheträffar räknas inte.</p></header>
    {needsKey && <form onSubmit={load} className="api-usage__login">
      <label htmlFor="admin-key">Administratörsnyckel</label>
      <div><input id="admin-key" type="password" autoComplete="off" value={key} onChange={(event) => setKey(event.target.value)} required /><button disabled={loading}>{loading ? "Hämtar…" : rows ? "Uppdatera" : "Visa statistik"}</button></div>
      {error && <p role="alert">{error}</p>}
    </form>}
    {!needsKey && error && <p className="api-usage__error" role="alert">{error}</p>}
    {!needsKey && !rows && !error && <p className="api-usage__empty">Hämtar statistik…</p>}
    {rows && <>
      <div className="api-usage__summary"><article><small>Totalt</small><strong>{sum(rows).toLocaleString("sv-SE")}</strong></article><article><small>Idag</small><strong>{(dailyTotals[today] || 0).toLocaleString("sv-SE")}</strong></article><article><small>Fel</small><strong>{failures.toLocaleString("sv-SE")}</strong></article></div>
      {!needsKey && <button type="button" className="api-usage__refresh" onClick={() => load()} disabled={loading}>{loading ? "Hämtar…" : "Uppdatera statistik"}</button>}
      {!rows.length ? <p className="api-usage__empty">Inga externa anrop har registrerats ännu.</p> : <div className="api-usage__grid">
        <section><h2>Anrop per dag</h2><div className="api-usage__bars">{days.map(([day, count]) => <div key={day}><time>{day}</time><span className="api-usage__bar"><i style={{ width: `${count ? Math.max(2, 100 * count / peak) : 0}%` }} /></span><strong>{count.toLocaleString("sv-SE")}</strong></div>)}</div></section>
        <section><h2>Tjänster</h2><ul>{providers.map(([name, count]) => <li key={name}><span>{name}</span><strong>{count.toLocaleString("sv-SE")}</strong></li>)}</ul><h2>Vanligaste anrop</h2><ul>{routes.slice(0, 12).map(([name, count]) => <li key={name}><span>{name}</span><strong>{count.toLocaleString("sv-SE")}</strong></li>)}</ul></section>
      </div>}
    </>}
  </main>;
}
